import React, { useMemo } from 'react';

/**
 * Sandboxed HTML flyer preview. Scripts and forms are blocked via iframe sandbox.
 */
export default function FabricTemplateHtmlFrame({
  html,
  title = 'Fabric template',
  className = '',
  fill = false,
}) {
  const srcDoc = useMemo(() => {
    const body = String(html || '').trim();
    if (!body) return '';
    const looksComplete = /<html[\s>]/i.test(body) || /<!doctype/i.test(body);
    if (looksComplete) return body;
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    html, body { margin: 0; padding: 0; width: 100%; height: 100%; background: #f3efe6; }
    body { box-sizing: border-box; }
    img { max-width: 100%; height: auto; }
  </style>
</head>
<body>${body}</body>
</html>`;
  }, [html]);

  if (!srcDoc) {
    return <div className={`bg-[#ebe4d8] ${className}`} />;
  }

  return (
    <iframe
      title={title}
      srcDoc={srcDoc}
      sandbox=""
      referrerPolicy="no-referrer"
      className={[
        'border-0 bg-white',
        fill ? 'absolute inset-0 h-full w-full' : 'w-full min-h-[280px] rounded-lg',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
